var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"g-tab"},[_c('router-link',{staticClass:"g-tab-item",attrs:{"active-class":"g-tab-item-active","to":{name: 'v4-order-personal'}}},[_vm._v("个人订单")]),_c('router-link',{staticClass:"g-tab-item",attrs:{"active-class":"g-tab-item-active","to":_vm.getRoutePath}},[_vm._v(" 供应商派单 ")])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }